var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{attrs:{"paginated":true,"data":_vm.jobs,"columns":_vm.columns,"default-sort":['ID', 'desc'],"hoverable":"","row-class":(row, index) => row.result.tag},on:{"click":_vm.rowClicked}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.debug),expression:"debug"}]},[_vm._v(" "+_vm._s(_vm.jobs)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }